import { ReactComponent as ArrowRight } from 'assets/icons/back.svg'
import React from 'react'
import classNames from 'classnames'
import { Tooltip } from '@material-ui/core'
import { ReactComponent as ErrorIcon } from 'assets/fields/error.svg'
import { ReactComponent as CheckIcon } from 'assets/icons/check-copy-2.svg'
import styles from 'components/Order/OrderDetails/OrderDetailsHeader.module.css'
import { useTranslation } from 'react-i18next'
import { ORDER_DATA_READ, ORDER_DELIVERY_POINT_READ, useAuth } from '../../../context/auth'
import CircularProgress from '@material-ui/core/CircularProgress'
import moment from "moment/moment";

export default function OrderDetailsHeader ({
                                              order,
                                              children,
                                              isMerchantLimitExceeded,
                                              verificationWarnings,
                                              carrier
                                            }) {
  const { t } = useTranslation()
  const getCountryAndZipCodePair = (deliveryPoint) => deliveryPoint.country + ' ' + deliveryPoint.zipCode
  const isOrderStatusSaved = order.status?.status === 'SAVED'
  const { hasAnyPrivileges } = useAuth()

  function getWarningIfNoVerificationAndHvVerification (noVerificationTitle) {
    return verificationWarnings.noVerification && !verificationWarnings.noHvVerification && t(noVerificationTitle);
  }

  function getWarningIfNoHvVerication (noHvVerificationTitle) {
    return verificationWarnings.noHvVerification && t(noHvVerificationTitle);
  }

  function getWarningIfVerificationExpired (expiredVerificationTitle) {
    return (!verificationWarnings.noVerification && !verificationWarnings.noHvVerification) &&
      verificationWarnings.carrierVerificationExpirationDate && !verificationWarnings.hvExpirationDate &&
      t(
        expiredVerificationTitle, { date: `${moment(carrier.carrierVerificationExpirationDate ? carrier.carrierVerificationExpirationDate : carrier.hvExpirationDate).format('DD-MM-YYYY')}` });
  }

  function getWarningIfHvVerficationExpired (expiredHVVerificationTitle) {
    return (!verificationWarnings.noVerification && !verificationWarnings.noHvVerification) && verificationWarnings.hvExpirationDate
      && t(expiredHVVerificationTitle, { date: `${moment(carrier.hvExpirationDate).format('DD-MM-YYYY')}` });
  }

  function getOrderIcon () {
    if (isMerchantLimitExceeded == null) {
      return <div className={'p-2'}><CircularProgress size={20}/></div>
    }

    const merchantLimitExceededTitle = 'order.details.isMerchantLimitExceededWarning'
    const merchantLimitIsAlrightTitle = 'order.details.isMerchantLimitAlrightInfo'
    const noVerificationTitle = 'order.warnings.carrier.noVerification'
    const noHvVerificationTitle = 'order.warnings.carrier.noHvVerification'
    const expiredVerificationTitle = 'order.warnings.carrier.carrierVerificationExpirationDateInfo'
    const expiredHVVerificationTitle = 'order.warnings.carrier.hvExpirationDateInfo'

    return (isMerchantLimitExceeded || hasVerificationWarnings()) ?
      <Tooltip title={
        <>
          {isMerchantLimitExceeded && t(merchantLimitExceededTitle)}
          {isMerchantLimitExceeded && hasVerificationWarnings() && <br/>}
          {getWarningIfNoVerificationAndHvVerification(noVerificationTitle)}
          {getWarningIfNoHvVerication(noHvVerificationTitle)}
          {getWarningIfVerificationExpired(expiredVerificationTitle)}
          {getWarningIfHvVerficationExpired(expiredHVVerificationTitle)}
        </>} arrow>
        <ErrorIcon className={styles.icon} height={24}/>
      </Tooltip> :
      <Tooltip title={t(merchantLimitIsAlrightTitle)} arrow>
        <CheckIcon className={styles.icon} height={20}/>
      </Tooltip>
  }

  const hasOrderDataReadPrivilege = hasAnyPrivileges([ORDER_DATA_READ])
  const hasOrderDeliveryPointsReadPrivilege = hasAnyPrivileges([ORDER_DELIVERY_POINT_READ])

  function hasVerificationWarnings () {
    return Object.values(verificationWarnings).some(item => item === true);
  }

  return <div className={classNames(styles.detailsRow)}>
    <div className={classNames(styles.titleRow)}>
      <div className={classNames(styles.titleRowWrapper)}>
        <div className={classNames(isOrderStatusSaved ? styles.orderIdBoxWithIcon : styles.orderIdBox)}>
          <h1>
            {hasOrderDataReadPrivilege ? 'ID ' + order.readableId : t('order.details.title')}
          </h1>
        </div>
        {getOrderIcon()}
        <div className={styles.destinationBox}>
          {hasOrderDeliveryPointsReadPrivilege && <h1>
            {getCountryAndZipCodePair(order.loadingDeliveryPoints[0])}
            {' '}
            <ArrowRight className={styles.arrow}/>
            {' '}
            {getCountryAndZipCodePair(order.unloadingDeliveryPoints[order.unloadingDeliveryPoints.length - 1])}
          </h1>
          }
        </div>
      </div>
    </div>
    <div style={{
      display: 'flex', paddingRight: '20px'
    }}>
      {children}
    </div>
  </div>

}
